/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Living_RoomInputs */

const cs_enum_living_room = /** @type {(inputs: Enum_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obývací pokoj`)
};

const en_enum_living_room = /** @type {(inputs: Enum_Living_RoomInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Living room`)
};

/**
* | output |
* | --- |
* | "Living room" |
*
* @param {Enum_Living_RoomInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_living_room = /** @type {((inputs?: Enum_Living_RoomInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Living_RoomInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_living_room(inputs)
	return cs_enum_living_room(inputs)
});